/*
  Live Leza product gallery controls on top of Dawn's media-gallery (loaded by product-media-gallery.liquid).
  - Desktop arrows: previous / next media, looping like the live site, through Dawn's setActiveMedia (which
    also moves the thumbnail highlight and announces the change).
  - Phone dots: one per slide in the current DOM order (a variant change can move its image to the front),
    following Dawn's slideChanged event; a dot scrolls the swipe slider to its slide.
  No image is requested early: both only show media that Dawn already renders.
*/
(() => {
  if (window.lezaGalleryReady) return;
  window.lezaGalleryReady = true;

  const slidesOf = (viewer) =>
    [...viewer.querySelectorAll('.product__media-list > [data-media-id]')].filter((slide) => slide.offsetParent !== null || !slide.hidden);

  const activeIndex = (viewer, slides) => {
    const active = slides.findIndex((slide) => slide.classList.contains('is-active'));
    return active < 0 ? 0 : active;
  };

  const buildDots = (viewer, current) => {
    const box = viewer.querySelector('[data-leza-gallery-dots]');
    if (!box) return;
    const slides = slidesOf(viewer);
    if (box.childElementCount !== slides.length) {
      box.replaceChildren(
        ...slides.map((slide, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'leza-gallery-dots__dot';
          dot.dataset.index = String(i);
          dot.setAttribute('aria-label', `${box.dataset.label} ${i + 1} ${box.dataset.of} ${slides.length}`);
          return dot;
        })
      );
    }
    [...box.children].forEach((dot, i) => {
      if (i === current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  const init = (gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || viewer.dataset.lezaGallery) return;
    viewer.dataset.lezaGallery = 'true';
    buildDots(viewer, 0);

    viewer.addEventListener('click', (event) => {
      const step = event.target.closest('[data-leza-gallery-step]');
      if (step) {
        const slides = slidesOf(viewer);
        if (slides.length < 2) return;
        const next = (activeIndex(viewer, slides) + Number(step.dataset.lezaGalleryStep) + slides.length) % slides.length;
        gallery.setActiveMedia(slides[next].dataset.mediaId, false);
        buildDots(viewer, next);
        return;
      }
      const dot = event.target.closest('.leza-gallery-dots__dot');
      if (dot) {
        const slides = slidesOf(viewer);
        const slide = slides[Number(dot.dataset.index)];
        if (!slide) return;
        slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        buildDots(viewer, Number(dot.dataset.index));
      }
    });

    // Swipe / Dawn slider updates (the event carries the slide now in view).
    viewer.addEventListener('slideChanged', (event) => {
      const slides = slidesOf(viewer);
      const index = slides.indexOf(event.detail && event.detail.currentElement);
      buildDots(viewer, index < 0 ? 0 : index);
    });

    // Variant changes re-order / re-activate media through Dawn: keep the dots in step.
    new MutationObserver(() => {
      const slides = slidesOf(viewer);
      buildDots(viewer, activeIndex(viewer, slides));
    }).observe(viewer.querySelector('.product__media-list'), { childList: true });
  };

  const start = () => document.querySelectorAll('media-gallery').forEach(init);
  if (customElements.get('media-gallery')) start();
  else customElements.whenDefined('media-gallery').then(start);
  document.addEventListener('shopify:section:load', start);
})();
